<template>
	<button
		class="button button--small"
		type="button"
		@click="show_form = !show_form"
	>
		{{ formTitle }}
	</button>
	<div
		v-if="show_form === true"
		class="simple-modal-wrapper"
	>
		<div class="simple-modal">
			<button
				class="simple-modal__close"
				aria-label="Close modal"
				@click="closeForm"
			/>
			<div class="simple-modal__content">
				<h2 class="simple-modal__heading">
					{{ formTitle }}
				</h2>
				<form
					@submit.prevent="locationNameForm"
				>
					<InputComponent
						:value="localised_form_fields.title"
						type="text"
						input-id="title"
						name="title"
						label="Location name"
						group-class="form__set--fixed-wide"
						:required="true"
						:errors="localised_form_errors.title || null"
						@update:value="new_value => localised_form_fields.title = new_value"
					/>
					<p
						v-if="project_location_form_errors"
						class="form__error pre-wrap"
					>
						{{ project_location_form_errors }}
					</p>
					<div class="flex flex--wrap flex--gap-large flex--align-center">
						<button
							class="button button--fill button--small"
							type="submit"
						>
							{{ formTitle }}
						</button>
						<button
							class="a a--no-underline a--small"
							type="button"
							@click="closeForm"
						>
							Cancel
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, defineProps, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const { createProjectLocation } = new_project_store;
const {
	project_location_form_fields,
	project_location_form_errors
} = storeToRefs( new_project_store );

const localised_form_errors = ref( [] );
const localised_form_fields = ref( {
	title: '',
	parent_id: '',
} );

const emit = defineEmits( ['refresh:project-locations'] );

const props = defineProps( {
	parentId: {
		required: true,
		type: String
	},
	fieldHandle: {
		required: true,
		type: String,
		default: null
	},
	formTitle: {
		required: false,
		type: String,
		default: null
	}
} );

const show_form = ref( false );

async function locationNameForm() {
	localised_form_errors.value = [];
	if ( localised_form_fields.value.title === '' ) {
		localised_form_errors.value.title = ['Please enter a new location name'];
	}
	if ( Object.keys( localised_form_errors.value ).length > 0 ) {
		return;
	}
	if ( localised_form_fields.value.title !== '' ) {
		project_location_form_fields.value.title = localised_form_fields.value.title;
	}
	if ( props.parentId !== '' ) {
		project_location_form_fields.value.parent_id = props.parentId;
	}
	if ( !project_location_form_errors.value ) {
		await createProjectLocation();
		emit( 'refresh:project-locations', project_location_form_fields.value.title );
		closeForm();
	}
}

function closeForm() {
	show_form.value = false;
	localised_form_fields.value.title = '';
	localised_form_errors.value = [];
	project_location_form_fields.value.title = '';
	project_location_form_fields.value.parent_id = '';
	project_location_form_errors.value = null;
}
</script>
